module.exports = __webpack_public_path__ + "img/ningguang.fe156bcf.webp";